import gql from 'graphql-tag';

export class ReminderMutations {
  static sms = gql`
    mutation sendSMSReminder(
      $documentId: String!
      $message: String!
      $isNotSignedSelected: Boolean!
      $isNotOpenedSelected: Boolean!
      $recipientIds: [String!]
    ) {
      sendSMSReminder(
        documentId: $documentId
        payload: {
          message: $message
          isNotSignedSelected: $isNotSignedSelected
          isNotOpenedSelected: $isNotOpenedSelected
          recipientIds: $recipientIds
        }
      )
    }
  `;

  static email = gql`
    mutation sendEmailReminder(
      $documentId: String!
      $isNotSignedSelected: Boolean!
      $isNotOpenedSelected: Boolean!
      $recipientIds: [String!]
    ) {
      sendEmailReminder(
        documentId: $documentId
        payload: {
          isNotSignedSelected: $isNotSignedSelected
          isNotOpenedSelected: $isNotOpenedSelected
          recipientIds: $recipientIds
        }
      )
    }
  `;

  static sendVideoReminder = gql`
    mutation sendVideoReminder($documentId: String!, $payload: VideoReminderEventInput!) {
      sendVideoReminder(documentId: $documentId, payload: $payload)
    }
  `;
}
